import { createContext, useContext } from "react";

// What a host (the new Studio) offers the chat for `json:studio` fences:
// describe a fence against the live state (labels, enabled, reasons), run
// one click action, and report what an action did. Absent outside the
// Studio — the block then renders labels only.

export interface StudioActionRow {
  index: number;
  group: "auto" | "click";
  label: string;
  /** The click row's button text ("Stage", "Run"). */
  button: string;
  enabled: boolean;
  reason?: string;
}

export interface StudioActionResult {
  ok: boolean;
  text: string;
  /** Still in flight (a run) — the row shows the text without a verdict. */
  pending?: boolean;
}

export interface StudioActionsHost {
  describe(code: string): { rows: StudioActionRow[]; errors: string[] };
  run(messageId: string, code: string, index: number): void;
  resultFor(
    messageId: string,
    code: string,
    index: number,
  ): StudioActionResult | undefined;
}

export const StudioActionsContext = createContext<StudioActionsHost | null>(
  null,
);

export function useStudioActionsHost(): StudioActionsHost | null {
  return useContext(StudioActionsContext);
}
